import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgTBankIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.98 16c0-7.542 0-11.314 2.343-13.657S9.437 0 16.98 0c7.542 0 11.313 0 13.656 2.343C32.98 4.686 32.98 8.458 32.98 16c0 7.543 0 11.314-2.344 13.657C28.293 32 24.522 32 16.98 32c-7.543 0-11.314 0-13.657-2.343C.979 27.314.979 23.543.979 16Z"
      fill="#FFDD2D"
    />
    <path
      d="M8.104 8.242h17.75V16.9c0 2.219-1.221 4.271-3.202 5.379l-5.673 3.175-5.673-3.175c-1.98-1.11-3.202-3.16-3.202-5.379V8.242Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.976 12.798v2.694c.38-.417 1.07-.696 1.86-.696h.858v3.13c0 .83-.234 1.56-.58 1.963h3.731c-.345-.402-.579-1.13-.579-1.96v-3.133h.858c.788 0 1.48.282 1.86.696v-2.694h-8.008Z"
      fill="#333"
    />
  </svg>
);
const Memo = memo(SvgTBankIcon);
export default Memo;
